import { useEffect, useState } from "react";
import { AnyAction } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";

/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../redux/store";
import colors from "../../constants/colors";
import { MOBILE } from "../../constants/breakpoints";

//Assets
import logo from "../../assets/logo_black.svg";
import link_small from "../../assets/icons/link_small.svg";
import connectWallet_btn from "../../assets/connectWallet_btn.svg";
import metamask from "../../assets/icons/wallets/metamask.svg";
import copy_small from "../../assets/icons/copy_small.svg";
import { ReactComponent as CheckIcon } from "../../assets/check.svg";

import wallet_yellow_outline from "../../assets/icons/wallet_yellow_outline.svg";
import menu from "../../assets/icons/menu.svg";
import wallet_mobile_nav from "../../assets/icons/wallet_mobile_nav.svg";
import logo_text from "../../assets/logo_text.svg";

//Local Components
import SubNav from "./SubNav";
import MobileMenu from "./MobileMenu";

//actions
import {
  openAssetInput,
  openWallet,
  walletDisconnect,
} from "../../redux/walletReducer";

import Button from "../Button";
import { browserNotSupported } from "../../module/routes/path";
import { Copy } from "../../shared/components/Copy/Copy";

const Nav = () => {
  const navigate = useNavigate();

  const detectBrowser = () => {
    const userAgent = navigator.userAgent;

    if (userAgent.indexOf('Chrome') > -1) {
      console.log('Google Chrome');
    } else if (userAgent.indexOf('Firefox') > -1) {
      console.log('Mozilla Firefox');
    } else if (userAgent.indexOf('Edg') > -1) {
      console.log('Microsoft Edge');
    } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
      console.log('Opera');
    } else {
      console.log('Apple Safari');
      navigate(browserNotSupported)
    }
  };
  useEffect(() => {
    if (!navigator?.userAgent) return
    detectBrowser();
  }, [navigator]);
  return (
    <>
      <MobileNav />
      <DesktopNav />
    </>
  );
};

const MobileNav = () => {
  const [mobileMenuToggle, setmobileMenuToggle] = useState(false);
  let walletState = useSelector((state: RootState) => state.walletState);
  let dispatch = useDispatch();
  return (
    <>
      {mobileMenuToggle && (
        <MobileMenu
          closeMenu={() => {
            setmobileMenuToggle(false);
          }}
        />
      )}
      <nav
        css={css`
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 15px;
          z-index: 10;
          position: sticky;
          top: 0;
          left: 0;
          @media (min-width: ${MOBILE + 1}px) {
            display: none;
          }
        `}
      >
        <img
          onClick={() => {
            setmobileMenuToggle(true);
          }}
          css={css`
            width: 36px;
            height: 36px;
            cursor: pointer;
          `}
          alt="menu-icon"
          src={menu}
        />
        <img
          css={css`
            width: 79.13px;
            height: 11.96px;
          `}
          alt="logo"
          src={logo_text}
        />
        {!walletState.address ? (
          <img
            css={css`
              width: 46px;
              height: 46px;
              cursor: pointer;
            `}
            alt="wallet"
            src={wallet_mobile_nav}
            onClick={() => {
              dispatch(openWallet());
            }}
          />
        ) : (
          <WalletState />
        )}
      </nav>
    </>
  );
};

function DesktopNav() {
  let walletState = useSelector((state: RootState) => state.walletState);
  let dispatch = useDispatch();
  return (
    <nav
      css={css`
        display: flex;
        margin: 0 auto;
        padding-top: 20px;
        height: 48px;
        width: 1140px;
        align-items: center;
        /* position: absolute;
        left: 0;
        right: 0; */
        z-index: 101;
        position: sticky;
        top: 0;
        left: 0;
        @media (max-width: ${MOBILE}px) {
          display: none;
        }
      `}
    >
      <a href="/">
        <img css={css`filter: drop-shadow(3px 1px 2px #fff);`} src={logo} alt="" />
      </a>
      <SubNav />
      <span
        css={css`
          display: flex;
          column-gap: 26px;
        `}
      >
        {["Pass", "Rewards"].map((link: string) => {
          return (
            <p
              key={"l" + link}
              css={css`
                display: flex;
                align-items: center;
                font-weight: 800;
                font-size: 16px;
                text-shadow: ${shadowRepeat(50)};
                color: ${colors.TEXT_WHITE};
                filter: drop-shadow(3px 1px 2px #fff);
              `}
            >
              {link}
              <img
                css={css`
                  margin-left: 8px;
                  opacity: 0.5;
                `}
                src={link_small}
                alt=""
              />
            </p>
          );
        })}
      </span>
      <span
        css={css`
          margin-left: auto;
        `}
      >
        {!walletState.address ? (
          <Button
            onClick={() => {
              dispatch(openWallet());
            }}
            width="168px"
            type="BLACK"
            iconSrc={wallet_yellow_outline}
          >
            Connect
          </Button>
        ) : (
          <WalletState />
        )}
      </span>
    </nav>
  );
}

const WalletState = () => {
  let walletState = useSelector((state: RootState) => state.walletState);
  const [ishover, setishover] = useState(false);
  const [isCopying, setIsCopying] = useState(false)

  let dispatch = useDispatch();
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        background: #f8e7ae;
        backdrop-filter: blur(60px);
        border-radius: ${ishover ? "24px 24px 0 0" : "24px 24px 24px 24px"};
        width: ${ishover ? "260px" : "177px"};
        height: 46px;
        margin-left: auto;
        align-items: center;
        padding: 0 11px;
        cursor: pointer;
        justify-content: center;
        position: relative;
        transition: all 0.35 ease-in-out;
        z-index: 9999;

        @media (max-width: ${MOBILE}px) {
          max-width: 46px;
          width: 46px;
          margin-left: 0;
        }
      `}
      onMouseEnter={() => {
        setishover(true);
      }}
      onMouseLeave={() => {
        setishover(false);
      }}
    >
      <span
        css={css`
          display: flex;
          width: 100%;
          justify-content: space-evenly;
        `}
      >
        <img
          css={css`
            width: 24.75px;
            object-fit: contain;
          `}
          src={metamask}
          alt=""
        />
        <p
          css={css`
            margin-left: auto;

            @media (max-width: ${MOBILE}px) {
              display: none;
            }
          `}
        >
          {minifyAddress(walletState.address as string)}
        </p>
        {
          isCopying ?
            <CheckIcon
              css={css`
                    margin-left: 5px;
                    circle{
                      fill: #96da96;
                    }
                    path{
                      fill: #036403;
                    }
                  `}
            />
            : <img
              css={css`
                margin-left: 8px;
                cursor: pointer;
                &:hover {
                  margin-left: 12px;
                  transform: scale(1.2);
                  transition: all 0.2s ease-in-out;
                }
                @media (max-width: ${MOBILE}px) {
                  display: none;
                }
              `}
              src={copy_small}
              alt=""
              onClick={() => {
                navigator.clipboard.writeText(walletState.address as string);
                setIsCopying(true)
                setTimeout(() => {
                  setIsCopying(false)
                }, 600);
              }}
            />
        }
      </span>
      {ishover && <WalletHover />}
    </div>
  );
};

const WalletHover = () => {
  let walletState = useSelector((state: RootState) => state.walletState);
  let dispatch = useDispatch();
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        width: 100%;
        background: #f8e7ae;
        backdrop-filter: blur(60px);
        position: absolute;
        top: 0;
        border-radius: 24px;
        align-items: center;
        justify-content: center;
        padding: 10px 16px;

        @media (max-width: ${MOBILE}px) {
          width: 260px;
          right: 0;
          top: 10px;
        }
      `}
    >
      <span
        css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
        `}
      >
        <span
          css={css`
            display: flex;
            width: 100%;
            justify-content: space-evenly;
          `}
        >
          <span
            css={css`
              display: flex;
              width: 46px;
              height: 46px;
              background: #ffffff4f;
              border-radius: 100%;
              justify-content: center;
              align-items: center;
            `}
          >
            <img
              css={css`
                width: 24.75px;
                object-fit: contain;
              `}
              src={metamask}
              alt=""
            />
          </span>

          <span
            css={css`
              margin-left: 7px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            `}
          >
            <p
              css={css`
                margin: 0;
                font-size: 14px;
                margin-top: 5px;
              `}
            >
              Wallet Address
            </p>
            <p
              css={css`
                font-weight: 400;
                font-size: 14px;
                margin: 0;
                color: #757272;
                margin-top: 5px;
              `}
            >
              {minifyAddress(walletState.address as string)}
            </p>
            <p
              css={css`
                font-weight: 700;
                font-size: 14px;
                margin: 0 auto;
                padding-top: 8px;
                padding-bottom: 14px;
                width: 100%;
                margin-bottom: 16px;
                &:hover {
                  color: #00000094;
                }
                border-bottom: 1px solid #0000001a;
                margin-top: 5px;
              `}
              onClick={() => {
                dispatch(walletDisconnect() as any as AnyAction);
              }}
            >
              Disconnect
            </p>
          </span>
          <Copy text={`${walletState.address}`} />
        </span>
      </span>
      <span
        css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
        `}
      >
        <span
          css={css`
            display: flex;
            width: 100%;
            justify-content: space-evenly;
          `}
        >
          <span
            css={css`
              display: flex;
              width: 46px;
              height: 46px;
              background: #ffffff4f;
              border-radius: 100%;
              justify-content: center;
              align-items: center;
            `}
          >
            <img
              css={css`
                width: 24.75px;
                object-fit: contain;
                filter: grayscale(100%) invert(50%);
              `}
              src={wallet_yellow_outline}
              alt=""
            />
          </span>

          <span
            css={css`
              margin-left: 7px;
              display: flex;
              flex-direction: column;
              justify-content: space-evenly;
              align-items: flex-start;
            `}
          >
            <p
              css={css`
                margin: 0;
                font-size: 14px;
                margin-top: 5px;
              `}
            >
              Asset Address
            </p>
            <p
              css={css`
                font-weight: 400;
                font-size: 14px;
                margin: 0;
                color: #757272;
                margin-top: 5px;
              `}
            >
              {minifyAddress(walletState.assetAddress as string)}
            </p>
            <p
              css={css`
                font-weight: 700;
                font-size: 14px;
                padding-top: 8px;
                padding-bottom: 8px;
                margin-top: 5px;
                margin-bottom: 0;
                &:hover {
                  color: #00000094;
                }
              `}
              onClick={() => {
                dispatch(openAssetInput() as any as AnyAction);
              }}
            >
              Update
            </p>
          </span>
          <Copy text={`${walletState.assetAddress}`} />
        </span>
      </span>
    </div>
  );
};

const minifyAddress = (address: string) => {
  if (!address) return ''
  return address?.slice(0, 5) + "..." + address?.slice(-4);
};

const shadowRepeat = (repeat: number): string => {
  let shadow = "0 0 1px black,";
  while (repeat) {
    shadow = shadow + " " + "0 0 1px black,";
    repeat--;
  }
  return shadow + " " + "0 0 1px black";
};

export default Nav;
